<style lang="less" scoped>
	.evanContent {
		display: -moz-box;
		display: -webkit-flexbox;
		display: -ms-flexbox;
		display: flex;
		.right {
			-webkit-box-flex: 1;
			-moz-box-flex: 1;
			-ms-flex: 1;
			flex: 1;
			padding-left: 30px;
		}
		.title {
			display: table;
			white-space: nowrap;
			text-align: center;
			background: 0 0;
			font-weight: 500;
			color: #17233d;
			font-size: 16px;
			margin: 16px 0;
		}
		.title:before,
		.title:after {
			box-sizing: border-box;
		}
		.title:before,
		.title:after {
			content: "";
			display: table-cell;
			position: relative;
			top: 50%;
			width: 50%;
			border-top: 1px solid #e8eaec;
			transform: translateY(50%);
		}
		.title .text {
			display: inline-block;
			padding: 0 24px;
			font-weight: 500;
			color: #17233d;
			font-size: 16px;
		}
		.titp_box-bom {
			padding: 16px;
			border: 1px solid #ffebcc;
			background-color: #fff5e6;
			border-radius: 6px;
			i {
				float: left;
				font-size: 28px;
				color: #f90;
				vertical-align: middle;
				margin: 12px 20px 0 10px;
			}
			p {
				margin: 0 0 0 58px;
			}
		}
	}
	.leftTree{
		width: 30%;
	}
	.right{
		width: 70%;
	}
</style>
<template>
	<div class="evanContent" id="treeCont">
		<ClTreeExtend class="cltree leftTree"  :treeData="treeData" :treeAction="treeAction" @treeNodeclick="treeNodeclick" searchHint="输入模型树名称进行过滤"></ClTreeExtend>
		<div class="right">
			<div class="title">
			</div>
			<!--模型列表-->
			<div v-show="showList">
				<Evtable :header="tableHeader" :tools="tools" :actions="action"
						 :quickSearchKey="quickSearchKey"
						 :quickSearchPlaceholder="quickSearchPlaceholder"
						 :params="params"
						 @refresh = "ths"
						 :url="url" actionWidth="100"
						 :searchData="searchDatas" @select="select" @selectAll="select">

					<template slot="empty">
						暂无数据！
					</template>

					<template slot="searchForm">

						<el-col :span="12">
							<el-form-item label="模型编码" prop="search_LIKE_modelCode">
								<el-input v-model.trim="searchDatas.search_LIKE_modelCode"
										  placeholder="请输入模型编码"></el-input>
							</el-form-item>
						</el-col>

						<el-col :span="12">
							<el-form-item label="模型名称" prop="search_LIKE_modelName">
								<el-input v-model.trim="searchDatas.search_LIKE_modelName"
										  placeholder="请输入模型名称">
								</el-input>
							</el-form-item>
						</el-col>

					</template>
				</Evtable>
			</div>
			<!--模型编辑与添加-->
			<div v-show="!showList">
				<div class="title">
					<span class="text">模型{{modelSubmitType=='edit'?'编辑':'添加'}}</span>

				</div>
				<Evform :model="editDatas"  :urlSubmit="editUrlSubmitValue"
						:submitType="editSubmitTypeValue" :loading="loading"
						:btnDoReset="addOrEdit" :rules="rules" label-width="90px"
						:beforSubmit="beforSubmit" :afterSubmit="afterSubmit"
						:btnDoCancal ="btnDoCancal" formName="editDatas" ref="editDatas">
					<el-col :span="12">
						<el-form-item label="模型名称" prop="modelName">
							<el-input placeholder="请输入模型名称" v-model.trim="editDatas.modelName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="模型编码" prop="modelCode">
							<el-input placeholder="请输入模型编码" v-model.trim="editDatas.modelCode"></el-input>
						</el-form-item>
					</el-col>
					<!--日期类型的选择-->
					<el-col :span="12">
						<el-form-item label="日期类型" prop="dateType">
							<el-select v-model.trim="editDatas.dateType" placeholder="日期类型">
								<el-option
										v-for="item in dateTypes"
										:key="item.type"
										:label="item.name"
										:value="item.type"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属地区" prop="areaCode">
							<el-cascader filterable
										 :props="{ checkStrictly: true }"
										 :options="areaList"
										 v-model.trim="editDatas.areaCode"
										 :clearable="false" size="small" placeholder="请选择地区" @change="handleChange">
							</el-cascader>
						</el-form-item>
					</el-col>
					<!--日期类型的选择-->
					<!--数据范围的选择-->
					<el-col :span="24">
						<el-form-item label="数据范围" prop="scopeType" id="mmp">
							<el-radio-group v-model="editDatas.scopeType" @change="changeRadio">
								<el-radio label="1">地区</el-radio>
								<el-radio label="2">景区</el-radio>
								<el-radio label="3">线路</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<template v-if="editDatas.scopeType==1">
						<el-col :span="20">
							<el-form-item prop="scopeCode" id="mmpammp">
								<el-cascader
										filterable
										:options="newAreaList"
										:props="{ multiple: true, checkStrictly: true }"
										v-model.trim="editDatas.scopeCode"
										clearable placeholder="请选择地区" id="areaStyle">
								</el-cascader>
							</el-form-item>
						</el-col>
					</template>
					<template v-if="editDatas.scopeType!=1&&editDatas.scopeType!=5">
						<el-col :span="20">
							<el-form-item  prop="scopeCode">

								<el-select  size="small" v-model="editDatas.scopeCode" multiple filterable clearable :placeholder="'请选择'+dataScopeName">
									<el-option
											v-for="(item,index) in dataScopes"
											:key="item.code"
											:label="item.name"
											:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</template>
					<!--数据范围的选择-->
					<el-col :span="24">
						<el-form-item label="模型配置" prop="modelMenu">
							<el-input type="textarea" rows="5" placeholder="模型配置" v-model="editDatas.modelMenu"></el-input>
						</el-form-item>
					</el-col>

					<template v-for="(domain, index) in editDatas.vsDsModelBindEntities" >
						<el-col :span="20"  :key="domain.key">
							<el-form-item label="接口名称" :prop="'vsDsModelBindEntities.'+index+'.shApiId'">
							<!--:rules="[{type:'string',required:true,message:'接口名称必须选择',trigger:'change'}]"-->
								<div>
									<treeselect
											class='treeBott'
											:options="interTreeData[0].children"
											:load-options="interLoadOptions"
											:normalizer="interNormalizer"
											:default-expand-level="0"
											:max-height="520"
											:disable-branch-nodes="true"
											:show-count="true"
											v-model="editDatas.vsDsModelBindEntities[index].shApiId"
											@select="interTreeSelected(index,$event)"
											:noResultsText="noResultsText"
											:clearAllText="clearAllText"
											:noOptionsText="noOptionsText"
											placeholder="请选择接口"/>
								</div>
							</el-form-item>
						</el-col>
						<el-col  :span="4">
							<el-button v-if="index==0" @click="addItem()" class="group-btn" style="display: inline-block;z-index: 1; position: relative;margin-top:4px" type="mini"  >添加</el-button>
							<el-button v-else @click="removeDomain(domain)" class="group-btn" style="display: inline-block;z-index: 1; position: relative;margin-top:4px"type="mini" >删除</el-button>
						</el-col>
						<el-col  :span="8">
							<el-form-item   label="子编码" :prop="'vsDsModelBindEntities.'+index+'.apiCode'">
								<!--:rules="[{required:true,message:'子编码不能为空',trigger:'blur'},{required: true,max: 10, message: '最多允许输入10个字符', trigger: 'blur'}]"-->
								<el-input placeholder="请输入子编码"  v-model="editDatas.vsDsModelBindEntities[index].apiCode" :name="index"></el-input>
							</el-form-item>
						</el-col>
						<el-col  :span="16">
							<el-form-item label="子名称" :prop="'vsDsModelBindEntities.'+index+'.apiName'">
								<!--:rules="[{type:'string',max: 20, message: '最多允许输入20个字符', trigger: 'blur'}]"-->
								<el-input placeholder="请输入子名称" v-model.trim="editDatas.vsDsModelBindEntities[index].apiName" :name="index"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item  label="接口参数"  :prop="'vsDsModelBindEntities.'+index+'.shApiPara'">
								<!--:rules="[{required:true,message:'接口参数不能为空',trigger:'blur'},{required: true,max: 50, message: '最多允许输入50个字符', trigger: 'blur'}]"-->
								<el-input type="textarea" v-model="editDatas.vsDsModelBindEntities[index].shApiPara" rows="4" resize="none"></el-input>
							</el-form-item>
						</el-col>
					</template>

					<el-col :span="12">
						<el-form-item label="排序" prop="seq">
							<ClInputNumber :min="0" v-model.trim="editDatas.sort" :max="100" placeholder="请输入排序值"></ClInputNumber>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						范围0~100，数值越小越靠前
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input type="textarea" placeholder="备注" v-model="editDatas.remark"></el-input>
						</el-form-item>
					</el-col>

				</Evform>
			</div>
		</div>

		<!-- 弹层 -->
		<el-dialog class="dialog" title="模型树新增" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" ref="clears">
			<cl-form class="dialog-form" :model="datas2" :fields="fields2" label-width="100px" :btnDoSubmit="treeNodeSubmit"
					 :btnShowReset="false" :btnShowCancal="false" :pageload="pageload" formName="clear">
				<cl-form-row class="fn-clear">
					<el-input ref="name" slot="name" v-model="datas2.name" placeholder="请输入模型树名称"></el-input>
				</cl-form-row>
				<cl-form-row class="fn-clear">
					<el-input ref="code" slot="code" v-model="datas2.code" placeholder="请输入模型树"></el-input>
				</cl-form-row>
				<cl-form-row class="fn-clear selectStyle">
					<el-input v-model="datas2.pid" style="display: none;"></el-input>
					<treeselect slot="pid" v-model="datas2.pid"
								:normalizer="normalizer"
								:show-count="true"
								:options="myroot"
								placeholder="请选择模型树父级" @select="treeSelected"
								:noResultsText="noResultsText"
								:clearAllText="clearAllText"
								:noOptionsText="noOptionsText" />
				</cl-form-row>
				<cl-form-row class="fn-clear">
					<ClInputNumber ref="sort" slot="sort" :min="0" v-model="datas2.sort" :max="100" placeholder="请输入排序值"></ClInputNumber>
					<span slot="reminder" class="reminder">范围0~100，数值越小越靠前</span>
				</cl-form-row>
				<cl-form-row class="fn-clear">
					<el-input type="textarea" ref="remark" slot="remark" v-model="editDatas.remark" placeholder="请输入模型树备注"></el-input>
				</cl-form-row>
			</cl-form>
		</el-dialog>

		<!--批量复制的弹层-->
		<el-dialog title="批量复制" id="model-create-copy" class="dialog edit-dialog-style" :visible.sync="dialogTableVisible">
			<model-create-copy  v-on:childByValue="reload" :selectMenuId="selectMenuId" :areaList="areaList"
								@pcopy="handelPcopy" :dialogTableVisible="dialogTableVisible" v-if="dialogTableVisible"></model-create-copy>
		</el-dialog>
		<!--批量复制的弹层-->
	</div>
</template>
<script>
	import Treeselect from "@riophae/vue-treeselect";
	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	import areaDataImport from "../../static/areaData";
	import ModelCreateCopy from "./modelCreateCopy";
	export default {
		components: {
			Treeselect,ModelCreateCopy
		},
		data() {
			var _this = this;
			const that = this;
			/******************树的校验*******************/
					//校验名称和编码
			const rulename = function(rule, value, callback) {
						_this.request
								.get("/bigdata-visual/modelbase/dsMenu/existByName", {
									name: _this.datas2.name,
									pid: _this.datas2.pid,
									id:_this.modelTreeType
								}).then(res => {
							if (res.status == 1) {
								return callback();
							} else {
								callback(new Error("该目录在同级目录中已存在"));
							}
						});
					};
			const rulecode = function(rule, value, callback) {
				_this.request
						.get("/bigdata-visual/modelbase/dsMenu/existByCode", {
							code: _this.datas2.code,
							id:_this.modelTreeType
						}).then(res => {
					if (res.status == 1) {
						return callback();
					} else {
						callback(new Error(res.msg));
					}
				});
			};
			const ruleScopeCode = function(rule, value, callback) {
				if(value==""){
					callback();
				}else{
					if(value.length>10){
						callback(new Error("最多只能选择10个"));
					}else{
						callback();
					}

				}
			};
			/*******************模型的校验********************/
			const modelCodeRule = function(rule, value, callback) {
				let areaCode = _this.editDatas.areaCode==undefined?'':_this.editDatas.areaCode;
				if(areaCode==""){
					return callback();
				}
				if(_this.editDatas.areaType==1){
					areaCode = _this.dealWithSubmitAreaCode(_this.editDatas.areaCode);//将选择的格式处理成我们需要的格式
				}
				/*校验前处理编码*/
				let scopeCode = "";
				if(_this.editDatas.scopeType==1){
					scopeCode = _this.dealWithSubmitScopeAreaCode(_this.editDatas.scopeCode,areaCode);
				}else if(_this.editDatas.scopeType!=5){
					if(typeof(_this.editDatas.scopeCode)=='object'){
						scopeCode = _this.editDatas.scopeCode.join(",");
					}
				}
				let scopeType = _this.editDatas.scopeType;
				if(scopeCode==''||scopeCode==undefined||scopeCode==[]){
					scopeCode = "";
					scopeType = "";
				}
				_this.request
						.get("/bigdata-visual/modelbase/vsDsModel/findByParas", {
							modelCode: _this.editDatas.modelCode,
							dateType: _this.editDatas.dateType,
							areaCode: areaCode,
							scopeType: scopeType,
							scopeCode: scopeCode,
							id:_this.openType
						}).then(res => {
					if (res.status == 1) {
						return callback();
					} else {
						callback(new Error(res.msg));
					}
				});
			};
			return {
				selectMenuId:-1,
				dialogTableVisible:false,//是否显示批量复制菜单
				userAreaCode:this.request.getSession('userInfo').org.areaCode==null?'':this.request.getSession('userInfo').org.areaCode,
				areaList:[],
				newAreaList:[],
				scenicData:[],
				dataScopeType:1,
				dataScopeName:'',
				dataScopes:[],
				options: [
				],
				value1: [],
				value2: [],
				refresh:null,
				quickSearchKey: "search_LIKE_modelName",
				quickSearchPlaceholder: "请输入模型名称",
				selected: [],
				changeOnSelect:true,
				dateTypes:[],
				scenicTypes:[],
				modelTreeType:-1,
				openType:'',
				editSubmitTypeValue:'',
				editUrlSubmitValue:'',
				valueFormat: "value",
				interLabelWidth: '80px',
				interMaxLevel: "2",
				interTreeData: [{
					label: "标签库",
					expand: false,
					id: "0",
					level: 0,
					name: "标签库",
					title: "标签库",
					children: []
				}],
				loading:true,
				rules: {
					modelCode: [
						{
							required: true,
							message: '不能为空',
							trigger: 'blur'
						}, {
							type: "string",
							pattern: this.regex.illcharacter,
							message: "含有非法字符",
							trigger: "blur"
						}, {
							type: "string",
							max: 32,
							message: "最多允许输入32个字符",
							trigger: "blur"
						},
						{
							type: "string",
							validator: modelCodeRule,
							trigger: "blur"
						}
					],
					areaCode: [
						{
							required: true,
							message: '不能为空',
							trigger: 'change'
						}
					],
					modelName: [
						{
							required: true,
							message: '不能为空',
							trigger: 'blur'
						}, {
							type: "string",
							pattern: this.regex.illcharacter,
							message: "含有非法字符",
							trigger: "blur"
						}, {
							type: "string",
							max: 32,
							message: "最多允许输入32个字符",
							trigger: "blur"
						}
					],
					dateType: [
						{
							required: true,
							message: '不能为空',
							trigger: 'change'
						}
					],
					scopeCode: [
						{
							type: "array",
							validator: ruleScopeCode,
							trigger: "change"
						}
					],
					scopeType:[

					],areaType:[
						{
							required: true,
							message: '不能为空',
							trigger: 'blur'
						}
					],
					remark: [{
						max: 512,
						message: "最多输入512个字符",
						trigger: "blur"
					}
					],
					modelMenu: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					},{
						max: 1000,
						message: "最多输入1000个字符",
						trigger: "blur"
					}
					],
					// apiCode:[{
					// 	max: 12,
					// 	message: "最多输入12个字符",
					// 	trigger: "blur"
					// }],
					// apiName:[{
					// 	max: 256,
					// 	message: "最多输入256个字符",
					// 	trigger: "blur"
					// }],
					// shApiPara:[{
					// 	max: 512,
					// 	message: "最多输入512个字符",
					// 	trigger: "blur"
					// }]
				},
				dataMenu:{},
				modelSubmitType:'edit',
				showList:true,
				txt: '123',

				pageload: false,
				search: '',

				showModal:false,
				indexVisible: false,
				// 分页数据
				//工具栏
				tools: [{
					name: 'modelCreate:c',//添加
					text: '新增',
					click: function () {
						that.modelSubmitType='add';
						that.openType = -1;
						//给出提示没有选择菜单,因为刚刚初始化的时候没有菜单id
						if(that.openType==-1&&that.modelMenuId==''){
							that.$message.error("请选择要添加在那个菜单下");
							return ;
						}
						that.modelFormInit();//添加之前先初始化
						that.addOrEdit();
						that.dateTypesInit();//获取日期类型选择的列表
					}
				}, {
					name: 'modelCreate:p',
					text: '批量删除',
					click: function (a, refesh) {
						if (that.selected.length == 0) {
							that.$message({
								showClose: true,
								message: "请至少选择一项",
								type: 'warning',
								duration: 2000
							})
						} else {
							that.bathdelete(that.selected, refesh);
						}
					}
				}, {
					name: 'modelCreate:pc',
					text: '批量复制',
					click: function (a, refesh) {
						if(that.modelMenuId!=-1&&that.modelMenuId!=undefined&&that.modelMenuId!=""){
							that.selectMenuId = that.modelMenuId;
							that.dialogTableVisible = true;
						}else{
                            that.$message({
                                showClose: true,
                                message: "请选择要复制的菜单",
                                type: 'warning',
                                duration: 2000
                            })
                        }
					}
				}
				],
				/*                // 工具栏
                                tools: [
                                    {
                                        name: 'refresh', //刷新按钮
                                    },{
                                        name: 'add', //添加
                                        fun: function () {
                                            that.modelSubmitType='add';
                                            that.openType = -1;
                                            //给出提示没有选择菜单,因为刚刚初始化的时候没有菜单id
                                            if(that.openType==-1&&that.modelMenuId==''){
                                                that.$message.error("请选择要添加在那个菜单下");
                                                return ;
                                            }
                                            that.modelFormInit();//添加之前先初始化
                                            that.addOrEdit();
                                            that.dateTypesInit();//获取日期类型选择的列表
                                        }
                                    },{
                                        name: 'select', //批量删除
                                        text: '批量删除',
                                        fun:function(a,b){
                                            if(a.length == 0){
                                                that.$message ({
                                                    showClose: true,
                                                    message: "请至少选择一项",
                                                    type: 'warning',
                                                    duration: 2000
                                                })
                                            }else{
                                                that.bathdelete(a,b);
                                            }
                                        }
                                    }, {
                                        name: 'query', //综合查询按钮
                                    }],*/
				// 列表数据
				tableHeader: [
					{
						type: "check",
						align: "center"
					}, {
						label: "模型编码",
						align: "center",
						prop: "modelCode",
						width: "80"
					},  {

						label: "模型名称",
						align: "center",
						prop: "modelName",

					},{
						label: "归属地区",
						align: "center",
						prop: "allAreaName",
						width: "100",

					},{
						label: "添加时间",
						align: "center",
						prop: "addTime",
						width: "150",
					}
				],
				datas: [],
				action:[
					{
						name: 'modelCreate:u',
						click: function(e) {
							that.openType = e.modelId;
							that.modelSubmitType='edit';
							that.addOrEdit();
						},
					}, {
						name: 'modelCreate:d',
						click: function(row, refesh) {
							let ids = [];
							ids.push(row.modelId);
							that.modelDelete('',ids, refesh);
						},
					}],
				searchfields: {
					row0: [{
						name: 'search_LIKE_modelCode',
						label: '模型编码',
						span: 12,

					}, {
						name: 'search_LIKE_modelName',
						label: '模型名称',
						span: 12,

					}]
				},
				searchDatas: {
					search_LIKE_modelCode: '',
					search_LIKE_modelName: ''
				},
				params:{menuId:-1},
				url:'/bigdata-visual/modelbase/vsDsModel/pageModelViewByMenuId',
				dialogVisible: false,//控制弹层
				treeAction: [
					{
						name: "添加",
						disabled: function(a, b) {
							if (a.level == 3) {
								return true;
							} else {
								return false;
							}
						},
						fun: function(e) {
							_this.modelTreeType = -1;
							_this.datas2.name = "";
							_this.datas2.code = "";
							_this.datas2.remark = "";
							_this.datas2.sort = 0;
							_this.datas2.pid = e.data.id;
							_this.dialogVisible = true;
							_this.pageload = false;
							return e;

						}
					},
					{
						name: "编辑",
						disabled: function(a, b) {
							if (a.level == 3) {
								return true;
							} else {
								return false;
							}
						},
						fun: function(e) {
							_this.modelTreeType = e.key;
							_this.request.get("/bigdata-visual/modelbase/dsMenu/"+e.key+"",{})
									.then(res => {
										if (res.status === 1) {
											let modelTree = res.data;
											_this.datas2.name = modelTree.menuName;
											_this.datas2.code = modelTree.menuCode;
											_this.datas2.remark = modelTree.menuDesc;
											_this.datas2.sort = modelTree.seq;
											_this.datas2.pid = modelTree.parentId;
											_this.dialogVisible = true;
											_this.pageload = false;
											return e;
										} else {
											_this.$message.error(res.msg);
										}
									})
									.catch(error => {
										console.log(error);
									});
							return e;

						}
					},
					{
						name: "删除",
						fun: function(e, b) {
							_this
									.$confirm("确认要删除吗?", "提示", {
										confirmButtonText: "确定",
										cancelButtonText: "取消",
										type: "warning"
									})
									.then(() => {
										_this.request.delete("/bigdata-visual/modelbase/dsMenu/", b.id)
												.then(res => {
													if (res.status === 1) {
														_this.$message.success(res.msg);
														_this.modalId = false;
														_this.showTable = true;
														_this.getAllTreeData();
													} else {
														_this.$message.error(res.msg);
													}
												})
												.catch(error => {
													console.log(error);
												});
									})
									.catch(() => {
										_this.$message({
											type: "info",
											message: "已取消删除"
										});
									});
							return e;
						}
					}
				],
				maxLevel: "2",
				treeData: [],//树的数据
				myroot: [],
				oldName: '',
				oldCode: '',
				//弹层
				fields2: {
					row1: [{
						name: "name",
						label: "模型树名称",
						span: 24,
						rules: [{
							required: true,
							message: "请输入模型树名称",
							trigger: "blur"
						},
							{
								min: 2,
								max: 20,
								message: "长度在 2 到 20 个字符",
								trigger: "blur"
							},
							{
								type: "string",
								validator: rulename,
								trigger: "blur"
							}
						]
					}],
					row2: [{
						name: "code",
						label: "模型树编码",
						span: 24,
						rules: [{
							required: true,
							message: "请输入模型树编码",
							trigger: "blur"
						}, {
							min: 2,
							max: 20,
							message: "长度在 2 到 20 个字符",
							trigger: "blur"
						}, {
							type: "string",
							validator: rulecode,
							trigger: "blur"
						}, {
							type: "string",
							pattern: /^[0-9_]+$/,
							message: "只能输入数字、下划线",
							trigger: "blur"
						}]
					}],
					row3: [{
						name: "pid",
						label: "父级模型树",
						span: 24,
						rules: [{
							required: true,
							message: "请选择父级模型树",
							trigger: "change"
						}]
					}],
					row4: [{
						label: "模型树排序",
						span: 24,
						rules: [{
							required: true,
							message: "输入不能为空",
							trigger: "blur"
						}],
						items: [{
							name: "sort",
							span: 10,
							rules: [{
								required: true,
								message: "输入不能为空",
								trigger: "blur"
							}]
						},
							{
								name: "reminder",
								span: 14
							}
						]
					}],
					row5: [{
						name: "remark",
						label: "模型树备注",
						span: 24,
						rules: [{
							max: 1024,
							message: "最多输入1024个字符",
							trigger: "blur"
						}]
					}]
				},
				datas: {
					menuId: "",
					name: "",
					remark: "",
					sort: 0,
					code: "",
					pid: "",
					isFlag: ""
				},
				datas2: {
					name: "",
					remark: "",
					sort: 0,
					code: "",
					pid: "",
				},
				noResultsText: "没有您要搜索的目录",
				noOptionsText: "暂无数据",
				clearAllText: "清除全部",
				modalLevel: 1,
				modalId: -1,
				editId: "",
				tabValue: 'dataEdit',
				/*编辑或者添加的数据*/
				editOprah: {},
				editOpenType: '',
				editPageload: false,
				editElOption: [],
				editFields: {
					row1: [{
						name: 'modelCode',
						label: '模型编码',
						span: 12,
						rules: [{
							required: true,
							message: '模型编码不能为空',
							trigger: 'blur'
						},{
							// pattern: /^[a-zA-Z]+$/,
							pattern: /^[^\u4e00-\u9fa5]+$/,
							message: '不能输入中文',
							trigger: 'blur'
						}, {
							min: 2,
							max: 32,
							message: '输入的字符长度在2-32之间',
							trigger: 'blur'
						}, {
							validator: true,//ruleModelCode,
							trigger: 'blur'
						}]
					}, {
						name: 'modelName',
						label: '模型名称',
						span: 12,
						rules: [{
							required: true,
							message: '请输入模型名称',
							trigger: 'blur'
						}, {
							min: 2,
							max: 32,
							message: '输入的字符长度在2-32之间',
							trigger: 'blur'
						}]
					}],
					row2: [{
						label: '数据绑定',
						name: 'remark',
						span: 24,
						rules: []
					}],
					row3: [{
						name: 'seq',
						label: '排序1',
						span: 24,
						rules: [{
							required: true,
							message: '排序不能为空',
							trigger: 'blur'
						}, {
							max: 20,
							message: '输入的字符长度在最大值为20',
							trigger: 'blur'
						}]
					}],
					row4:[{
						name: 'remark',
						label: '备注',
						span: 24,
						rules: [{
							min: 2,
							max: 512,
							message: '输入的字符长度在2-512之间',
							trigger: 'blur'
						}]
					}]
				},
				editDatas: {
					vsDsModelBindEntities:[
						{
							"dsModelId": "",
							"shApiId": null,
							"shApiPara": "",
							"apiCode":'',
							"apiName":''
						}
					],
					modelMenu:'',
					menuId: '',
					modelCode: '',
					modelData: '',
					modelName: '',
					dateType:'',
					remark: '',
					seq: '',
					areaCode:'',
					areaType:'1',
					scenicCode:'',
					scopeCode:"",
					scopeType:""
				},
				modelMenuId:'',
				modelSubmitData:{

				}
			};
		},
		computed: {
			urlSubmit() {
				let that = this;
				that.datas.id = that.modalId;
				return "/bigdata-visual/modelbase/dsMenu" + this.modalId;
			},
			scopeType(){
				return this.editDatas.scopeType
			},
			areaType(){
				return this.editDatas.areaType;
			}
		},
		watch:{
			openType(newType,oldType){
				this.editSubmitTypeValue = this.editSubmitType();
				this.editUrlSubmitValue = this.editUrlSubmit();
			},
			scopeType(newType,oldType){
				let dataScopeName = ''
				if(newType!=1){
					if(newType==2){
						dataScopeName = '景区'
					}
					if(newType==3){
						dataScopeName = '线路'
					}
					this.getDataScope(newType,this.editDatas.areaCode);
				}else{
					dataScopeName = '线路';
				}
				this.dataScopeName = dataScopeName
			}
		},
		methods: {
			handelPcopy(msg){
				this.refresh();
			},
			reload(){},
			handleChange(value, selectedData) {
				let that = this;
				this.editDatas.scopeCode=[];
				this.getAreaList(value);
				if(this.editDatas.scopeType!=""){
					if(this.editDatas.scopeType!=1){
						let areaCode = value.join("").padEnd(6,'0');
						this.getDataScope(this.editDatas.scopeType,areaCode);
					}
				}
			},
			getAreaList(value){

				let areaList = [];
				let newAreaDataImport = areaDataImport.concat();
				newAreaDataImport.map(function (item) {//国内的值
					if (item.value == 86) {
						areaList = item.children;
					}
				});
				let newAreaList = areaList.concat();
				if(value.length==1){
					newAreaList = newAreaList.filter(item => {
						return value[0] == item.value;
					})
				}else if(value.length==2){
					newAreaList = newAreaList.filter(item => {
						return value[0] == item.value;
					})
					newAreaList = newAreaList[0]['children'].filter(item => {
						return value[1] == item.value;
					})
				}else if(value.length==3){
					newAreaList = newAreaList.filter(item => {
						return value[0] == item.value;
					})
					newAreaList = newAreaList[0]['children'].filter(item => {
						return value[1] == item.value;
					})
					newAreaList = newAreaList[0]['children'].filter(item => {
						return value[2] == item.value;
					})
				}
				this.newAreaList = newAreaList;

			},
			changeRadio(e){
				//切换之前清空之前保存的
				this.editDatas.scopeCode="";
			},
			changeAreaRadio(e){
				// if(e==2){
				// 	this.editDatas.areaCode=[];
				// }else{
				// 	this.editDatas.scenicCode="";
				// }
			},
			select(e) {
				this.selected = e;
			},
			copyDeep(templateData) {
				// templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
				return JSON.parse(JSON.stringify(templateData));
			},
			lyArea() {
				let that = this;
				let userAreaCode = that.userAreaCode;
				let newAreaDataImport = that.copyDeep(areaDataImport);//深拷贝
				let areaList = [];
				newAreaDataImport.map(function (item) {//国内的值
					if (item.value == 86) {
						areaList = item.children;
					}
				});
				let newAreaList = areaList.concat();
				if(userAreaCode!=null&&userAreaCode!=""){
					let areaLength=userAreaCode.length;
					if(areaLength==2){
						newAreaList = newAreaList.filter(item => {
							return item.value==userAreaCode.substr(0,2);
						})
					}else if(areaLength==4){
						newAreaList = newAreaList.filter(item => {
							return item.value==userAreaCode.substr(0,2);
						})
						newAreaList.map(function(item){
							item.disabled = true;
							return item;
						})
						newAreaList[0].children = newAreaList[0].children.filter(item => {
							return item.value==userAreaCode.substr(2,2);
						})
					}else if(areaLength==6){
						newAreaList = newAreaList.filter(item => {
							return item.value==userAreaCode.substr(0,2);
						})
						newAreaList.map(function(item){
							item.disabled = true;
							return item;
						})
						newAreaList[0].children = newAreaList[0].children.filter(item => {
							return item.value==userAreaCode.substr(2,2);
						})
						newAreaList[0].children.map(function(item){
							item.disabled = true;
							return item;
						})
						newAreaList[0].children[0].children = newAreaList[0].children[0].children.filter(item => {
							return item.value==userAreaCode.substr(4,2);
						})
					}
				}
				that.areaList = newAreaList;
			},
			dateTypesInit () {
				let _that = this;
				_that.request.get('/bigdata-visual/modelData/sysParam/findListByKey/model_date_type').then((res) => {
					_that.dateTypes = res.data;
				})
			},
			getDataScope(type,areaCode){
				if(typeof(areaCode)=='object'){
					areaCode = areaCode.join("").padEnd(6,'0');
				}
				let _that = this;
				_that.request.get('/bigdata-visual/modelbase/vsDsModelDataScope/findByTypeAndAreaCode',{
					type: type,
					areaCode: areaCode
				}).then((res) => {
					_that.dataScopes = res.data;
				})
			},
			modelFormInit(){
				this.editDatas.vsDsModelBindEntities=[]

				this.editDatas.vsDsModelBindEntities=[
					{
						"dsModelId": "",
						"shApiId": null,
						"shApiPara": "",
						"apiCode":'',
						"apiName":''
					}
				],
						this.editDatas.modelId='';
						this.editDatas.menuId= '',
						this.editDatas.modelCode= '',
						this.editDatas.modelData= '',
						this.editDatas.modelName= '',
						this.editDatas.remark= '',
						this.editDatas.seq= ''

			},
			btnDoCancal(){
				this.showList = true;
			},
			afterSubmit(e){
				//模型表单提交后刷新列表并让列表显示出来
				e.message
				console.log(e)
				// let tipInfo = "操作完成";
				// if(e==0){
				//     tipInfo = "操作失败";
				// 	this.$message({
				// 		message: tipInfo,
				// 		type: "error"
				// 	})
				// }else{
				// 	this.$message({
				// 		message: tipInfo,
				// 		type: "success"
				// 	})
				// }
				this.refresh();
				this.showList = true;
			},
			beforSubmit(e) {
				//提交之前先把接口中没有选择的删除了
				let vsDsModelBindEntitiesResult = [];
				let vsDsModelBindEntities = e.vsDsModelBindEntities;
				vsDsModelBindEntities.map(function(item){
					if(item.shApiId!=null&&item.shApiId!=''){
						vsDsModelBindEntitiesResult.push(item);
					}
				});
				e.vsDsModelBindEntities = vsDsModelBindEntitiesResult;
				if(e.menuId ==''){
					e.menuId = this.modelMenuId;
				}
				/*********************************处理提交参数*****************************************/
				let myAreaCode = e.areaCode.join("");
				/*************处理归属地区************/
				if(e.areaType==1){
					let areaCode = this.dealWithSubmitAreaCode(e.areaCode);
					e.areaCode=areaCode;
				}
				/*************处理数据范围***********/
				let scopeCode = "";
				if(e.scopeType==1){
					scopeCode = this.dealWithSubmitScopeAreaCode(e.scopeCode,myAreaCode);
					e.scopeCode=scopeCode;
				}else if(e.scopeType!=5){
					if(typeof(e.scopeCode)=='object'){
						scopeCode = e.scopeCode.join(",");
					}
					e.scopeCode=scopeCode;
				}
				/******************如果数据范围下面的值为空则数据范围类型也为空*******************/
				if(e.scopeCode==''||e.scopeCode==undefined||e.scopeCode==[]){
					e.scopeType = "";
					e.scopeCode = "";
				}
				/*********************************处理提交参数*****************************************/

			},
			dealWithRequestAreaCode(areaCode){
				if(areaCode.length!=6){
					areaCode = areaCode.substr(0,6)
				}
				let reg = /(\d{2})/;
				let childList = areaCode.split(reg);
				let newChildList = [];
				childList.map(function (item) {
					if (item!=""&&item!="00"){
						newChildList.push(item);
					}
				});
				return newChildList;
			},
			dealWithRequestScopeAreaCode(areaCode){
				let areaResult=[];
				if(areaCode!=null&&areaCode!=""){
					let childs = areaCode.split(",");
					for(let i=0;i<childs.length;i++){
						let child = childs[i];
						let reg = /(\d{2})/;
						let childList = child.split(reg);
						let newChildList = [];
						childList.map(function (item) {
							if (item!=""&&item!="00"){
								newChildList.push(item);
							}
						});
						if(newChildList!=null&&newChildList!=""&&newChildList.length>0){
							areaResult.push(newChildList);
						}
					}
				}
				return areaResult;
			},
			dealWithSubmitAreaCode(areaCode){
				areaCode = areaCode.join("");
				areaCode = areaCode.padEnd(6,"0")
				return areaCode;
			},
			echoScopeAreaCode(areaCode,curAreaCode){
				if(curAreaCode.length==2){
					areaCode.map(function(item){
						item.shift();
						return item;
					})
				}else if(curAreaCode.length==3){
					areaCode.map(function(item){
						item.shift();
						item.shift();
						return item;
					})
				}else{

				}
				return areaCode;
			},
			dealWithSubmitScopeAreaCode(areaCode,curAreaCode){
				let areaResult=[];
				if(curAreaCode!=""){
					while (true){
						if(curAreaCode.substr(curAreaCode.length-2,curAreaCode.length-2)==0){
							curAreaCode = curAreaCode.substr(curAreaCode.length-2,curAreaCode.length-2);
						}else{
							break;
						}
						if(curAreaCode.length<=0){
							break;
						}
					}

				}
				if(areaCode!=null&&areaCode!=""){
					for(let i=0;i<areaCode.length;i++){
						let result = areaCode[i].join("").padEnd(6,"0");
						result = curAreaCode.substr(0,curAreaCode.length-2).toString()+result.toString();
						result = result.substr(0,6)
						areaResult.push(result);
					}
				}
				return areaResult.join(",");
			},
			editSubmitType() {
				return this.openType === -1 ? 'post' : 'put';
			},
			editUrlSubmit() {
				return this.openType === -1 ? '/bigdata-visual/modelbase/vsDsModel' : ('/bigdata-visual/modelbase/vsDsModel/' + this.openType);
			},
			beforeClearAll(){
				this.datas2.newTags = [];
			},
			interLoadOptions({action, parentNode, callback}) {
				if (action == "LOAD_CHILDREN_OPTIONS") {
					switch (parentNode.id) {
						case "success": {
							simulateAsyncOperation(() => {
								parentNode.children = [
									{
										id: "child",
										label: "Child option"
									}
								];
								callback();
							});
							break;
						}
						case "no-children": {
							simulateAsyncOperation(() => {
								parentNode.children = [];
								callback();
							});
							break;
						}
						case "failure": {
							simulateAsyncOperation(() => {
								callback(
										new Error(
												"Failed to load options: network error."
										)
								);
							});
							break;
						}
						default: /* empty */
					}
				}
			},
			//动态添加
			addItem() {
				if (this.editDatas.vsDsModelBindEntities.length < 6) {
					this.editDatas.vsDsModelBindEntities.push(
							{
								"dsModelId": "",
								"shApiId": null,
								"shApiPara": "",
								"apiCode":'',
								"apiName":''
							}
					);
				} else {
					this.$message.error("数据接口最多添加6条数据");
				}
			},
			//动态删除数据接口
			removeDomain(item) {
				let index = this.editDatas.vsDsModelBindEntities.indexOf(item)
				if (index !== -1) {
					this.editDatas.vsDsModelBindEntities.splice(index, 1)
				}

			},
			modelDelete(tips,ids, refesh){
				this.$confirm('确认要删除'+tips+'模型吗?', '操作确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.request.deleteParam("/bigdata-visual/modelbase/vsDsModel/"+ids.join()).then(res => {
						if (res.status === 1) {
							this.$message({
								message: '删除成功',
								type: "success"
							});
							refesh();//删除后刷新
						} else if (res.status === 0) {
							this.$message.error(res.msg ? res.msg : '删除失败');
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			ths(e){
				this.refresh= e;
			},
			handleCancal(){
				this.showList ='true';
			},
			/*            refresh(e){
                            this.refs = e.refresh
                        },*/
			//弹层关闭
			handleClose() {
				this.dialogVisible = false;
				this.pageload = false;
				this.$refs['clears'].$children[0].$refs['clear'].resetFields()
			},
			interTreeSelected(index,node) {
				this.editDatas.vsDsModelBindEntities[index].apiCode= node.apiCode;
				this.editDatas.vsDsModelBindEntities[index].shApiPara = node.shApiPara;
				this.modalLevel = node.level;
			},
			treeSelected(node, instanceId) {
				// node.level === 0 ? this.fields2.row4[0].hide = false : this.fields2.row4[0].hide = true;
				this.modalLevel = node.level;
			},
			interNormalizer(node) {
				let label = node.title;
				if (label == undefined){
					label = "匹配不到名称";
				}
				return {
					id: node.id,
					label: label,
					shApiPara:node.shApiPara,
					children:
							node.children && node.children.length > 0
									? node.children
									: node.level == 1
									? null
									: "null"
				};
			},
			normalizer(node) {
				return {
					id: node.id.toString(),
					label: node.name,
					children: node.children && node.children.length > 0 ? node.children : "null",
					isDisabled: node.level === 2 ? true : false
				};
			},
			//新增模型树提交
			treeNodeSubmit() {
				let _this = this;
				_this.pageload = true;
				_this.dataMenu.parentId = _this.datas2.pid;
				_this.dataMenu.menuName = _this.datas2.name;
				_this.dataMenu.menuCode = _this.datas2.code;
				_this.dataMenu.menuDesc = _this.datas2.remark;
				_this.dataMenu.seq = Number(_this.datas2.sort);
				let modelTreeUrl = _this.modelTreeType==-1?'/bigdata-visual/modelbase/dsMenu':'/bigdata-visual/modelbase/dsMenu/'+_this.modelTreeType;
				if(_this.modelTreeType==-1){
					_this.request.post(modelTreeUrl, _this.dataMenu).then(res => {
						if (res.status === 1) {
							_this.$message.success(res.msg);
							_this.getAllTreeData();
							_this.dialogVisible = false;
							_this.$message.success("提交成功");
						} else {
							_this.$message.error("提交失败");
							_this.dialogVisible = false;
						}
						_this.pageload = false;
					}).catch(error => {
						console.log(error);
					});
				}else{
					_this.request.put(modelTreeUrl, _this.dataMenu).then(res => {
						if (res.status === 1) {
							_this.$message.success(res.msg);
							_this.getAllTreeData();
							_this.dialogVisible = false;
						} else {
							_this.$message.error("更新失败");
							_this.dialogVisible = false;
						}
						_this.pageload = false;
					}).catch(error => {
						console.log(error);
					});
				}

			},
			getAllInterfaceData() {
				let that = this;
				that.request
						.get("/bigdata-visual/modelData/shApi/findTree", {
						})
						.then(res => {
							if (res.status === 1) {
								let tagData = res.data.filter(item => {
									return (item.children != null && item.children.length != 0);
								})
								const child = that.getsorl(tagData, that.maxLevel);
								that.interTreeData[0].children = child;
							} else {
								//that.$message.error(res.msg);
							}
						});
			},
			//获取树形数据
			getAllTreeData() {
				let that = this;
				that.pageload = true;
				that.request
						.get("/bigdata-visual/modelbase/dsMenu/noRightTree", {
							pid: '000'
						}).then(res => {
					if (res.status === 1) {
						if(res.data == null || res.data.length == 0){
							that.treeData = [{
								children: [],
								expand: true,
								id: "-1",
								level: 0,
								label: "初始目录",
								name: "根目录",
								title: "根目录"
							}];
							that.myroot = [{
								children: [],
								expand: true,
								id: "-1",
								level: 0,
								name: "根目录",
								title: "根目录"
							}];
						}else{
							that.showRight = true;
							that.showData = false;
							let roots = [];
							if (res.data != null && res.data.length > 0) {
								for (let i = 0; i < res.data.length; i++) {
									let temp = res.data[i];
									let tempRoot = {
										id: temp.id,
										level: 0,
										expand: true,
										title: temp.name,
										label: temp.name,
										name: temp.name,
										children: that.getsorl(temp[temp.id], that.maxLevel)
									};
									roots.push(tempRoot)
								}
							}
							that.treeData = roots;
							that.myroot = [{
								children: roots,
								expand: true,
								id: "-1",
								level: 0,
								name: "根目录",
								title: "根目录"
							}];
						}
					}else {
						//that.$message.error("获取模型树树数据失败");
					}
					that.pageload = false;
				}).catch(() => {
					that.$message.error("请求出错");
					that.pageload = false;
				});
			},
			//树形结构添加排序值
			getsorl(data, foolr) {
				for (var i in data) {
					if (data[i].level === foolr) {
						data[i].name = data[i].title;
						data[i].title = data[i].name;
						data[i].label = data[i].name;
					} else {
						this.getsorl(data[i].children, foolr);
						data[i].name = data[i].title;
						data[i].title = data[i].name;
						data[i].label = data[i].name;
					}
				}
				return data;
			},
			//树点击事件
			treeNodeclick(node, data) {
				const _self = this;
				_self.pageload = true;
				_self.modalLevel = data.level === 0 ? false : true;
				if (data.level > 1) {
					let nodeKey = node;
					let rootId = '';
					while (true) {
						let result = getRootId(nodeKey);
						if (result.isStop) {
							rootId = result.id;
							break;
						} else {
							nodeKey = result.id;
						}
					}

					function getRootId(datas) {
						if (datas.level == '1') {
							return {
								isStop: true,
								id: datas.key
							};
						} else {
							return {
								isStop: false,
								id: datas.parent
							};
						}
					}
					if (rootId != '1') {
						_self.showTable = false;
						_self.tabValue = "dataEdit";
					} else {
						_self.showTable = true;
					}
				} else {
					_self.showTable = true;
				}
				_self.editId = data.id;

				_self.params={menuId : _self.editId};
				_self.modelMenuId = _self.editId;//给模型数据添加菜单id
				_self.showList  = true;

			},
			bathdelete:function(a,refesh){
				let ids=[];
				for(let i=0;i<a.length;i++){
					let item=a[i];
					ids.push(item.modelId);
				}
				this.modelDelete('这些',ids, refesh);
			},
			resetForm () {
				this.$refs['editDatas'].$refs['EvanForm'].clearValidate();//重置前清空验证消息
			},
			//模型的新增、修改、重置
			addOrEdit() {
				let _this = this;
				this.request.getId('/bigdata-visual/modelbase/vsDsModel/', _this.openType).then((res) => {
					this.editPageload = false;
					this.showList = false;
					this.dateTypesInit();//获取日期类型选择的列表
					if(res.data!=undefined&&res.data!=null){
						const editDatas = res.data;
						for (let key in this.editDatas) {
							if (!editDatas[key]) {
								this.editDatas[key] = ''
							} else {
								this.editDatas[key] = editDatas[key]
							}
						}
						if(editDatas.vsDsModelBindEntities==undefined||editDatas.vsDsModelBindEntities==null){
							editDatas.vsDsModelBindEntities=[{
								"dsModelId": "",
								"shApiId": null,
								"shApiPara": "",
								"apiCode":'',
								"apiName":''
							}];
						}else{
							for (let i=0 ; i< editDatas.vsDsModelBindEntities.length;i++) {

							}
						}
						/*******************************************处理回显****************************************************/
						/****************归属地区类型的回显*****************/
						if(editDatas.areaType==null||editDatas.areaType==""){
							editDatas.areaType = "";
						}
						/****************数据范围地区等的回显*****************/
						let scopeCode ='';
						if(editDatas.scopeType==1){
							scopeCode= _this.dealWithRequestScopeAreaCode(editDatas.scopeCode);
						}else if (editDatas.scopeType=="") {
							scopeCode = [];
						}else{
							scopeCode = editDatas.scopeCode.split(',');
						}
						editDatas.scopeCode = scopeCode;
						/****************归属地区的回显*****************/
						if(editDatas.areaType==1){
							_this.getDataScope(editDatas.scopeType,editDatas.areaCode)
							editDatas.areaCode = _this.dealWithRequestAreaCode(editDatas.areaCode);
						}
						/********************根据所选地区过滤的数据范围的数据****************************/
						if(editDatas.scopeType!=""){
							if(editDatas.scopeType==1){
								_this.getAreaList(editDatas.areaCode);
							}else{
								let areaCode = editDatas.areaCode.join("").padEnd(6,'0');
								_this.getDataScope(editDatas.scopeType,areaCode);
							}
						}else{
							_this.getAreaList(editDatas.areaCode);
						}
						//专门处理数据范围地区的回显问题
						if( typeof(editDatas.scopeCode)=='object'&&editDatas.scopeCode.length>0&&editDatas.scopeType==1){
							editDatas.scopeCode = _this.echoScopeAreaCode(editDatas.scopeCode,editDatas.areaCode);
						}
						/*******************************************处理回显****************************************************/
						_this.editDatas = editDatas;
					}else{
						_this.editDatas.areaType = '1';
						_this.editDatas.areaCode = [];
						/************************新增默认选中当前用户的地区******************************/
						_this.editDatas.areaCode = [];
						if(_this.userAreaCode!=null&&_this.userAreaCode!=''){
							if(_this.userAreaCode.length==2){
								_this.editDatas.areaCode.push(_this.userAreaCode);
							}else if(_this.userAreaCode.length==4){
								_this.editDatas.areaCode.push(_this.userAreaCode.substr(0,2));
								_this.editDatas.areaCode.push(_this.userAreaCode.substr(2,2));
							}else if(_this.userAreaCode.length==6){
								_this.editDatas.areaCode.push(_this.userAreaCode.substr(0,2));
								_this.editDatas.areaCode.push(_this.userAreaCode.substr(2,2));
								_this.editDatas.areaCode.push(_this.userAreaCode.substr(4,2));
							}
						}
						/************************新增默认选中当前用户的地区******************************/
						_this.editDatas.scopeType = '';
						_this.editDatas.scopeCode= [];
						_this.editDatas.modelMenu = "";
						_this.editDatas.dateType = "";
						_this.newAreaList = [];//测试说的功能缺陷
						_this.openType = -1;
						_this.modelFormInit();
						_this.resetForm ();
					}
				})
			},
		},
		created() {
			this.loading = false;
			this.getAllInterfaceData();//获取接口树
			this.getAllTreeData();//获取树
			this.modalId = false;//?
			this.request.oprahfun(this);
			this.lyArea();
		},
		mounted() {
			let $clMain = document.getElementsByClassName("cl-main")[0],
					$treeBox = $clMain.getElementsByClassName("el-tree")[0],
					$right = $clMain.getElementsByClassName("right")[0],
					$clMainH = $clMain.offsetHeight;
			$treeBox.style.height = ($clMainH - 80) + "px";
			$treeBox.style.overflow = "hidden";
			$treeBox.style["overflow-y"] = "scroll";

			$right.style.height = ($clMainH - 80) + "px";
			$right.style.overflow = "hidden";
			$right.style["overflow-y"] = "scroll";
			window.onresize = function windowResize () {
				// 通过捕获系统的onresize事件触发我们需要执行的事件
				let $clMain = document.getElementsByClassName("cl-main")[0],
						$treeBox = $clMain.getElementsByClassName("el-tree")[0],
						$right = $clMain.getElementsByClassName("right")[0],
						$clMainH = $clMain.offsetHeight;
				$treeBox.style.height = ($clMainH - 80) + "px";
				$treeBox.style.overflow = "hidden";
				$treeBox.style["overflow-y"] = "scroll";

				$right.style.height = ($clMainH - 80) + "px";
				$right.style.overflow = "hidden";
				$right.style["overflow-y"] = "scroll";
			}
		}
	};
</script>
<style scoped>

	#treeCont .el-tree {
		width: 100%
	}

	#treeCont .el-input__inner {
		width: 100%
	}
	.treeBott{
		margin-bottom: 10px;
	}
	.treeBott.vue-treeselect .vue-treeselect__control {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 28px;
		line-height: 28px;
		color: #fff;
	}
	#treeCont > input{
		height: 28px;
	}
	/*   #areaStyle, #areaStyle .el-input__inner,#areaStyle el-input,#areaStyle>.el-cascader>.el-input__inner{
            height: 28px;
        }*/
	#areaStyle > div.el-input.el-input--mini.el-input--suffix > input{
		height: 30px;
	}

	.treeBott .vue-treeselect__control,
	.treeBott .vue-treeselect__value-container,
	.treeBott .vue-treeselect__input-container,
	.treeBott .vue-treeselect__input,.treeBott{
		height:28px!important;
	}


</style>
<style>
	.el-cascader-menu__empty-text {
		position: relative !important;
		top: 0% !important;
		left: 0% !important;
		-webkit-transform: translate(0%,0%)!important;
		transform: translate(0%,0%)!important;
		text-align: center !important;
	}

</style>